'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import I18n from 'I18n';
import ComponentData from './ComponentData';
import GradeTypeConstants from '../../constants/GradeTypeConstants';

var YesNoData = /*#__PURE__*/function (_ComponentData) {
  _inherits(YesNoData, _ComponentData);

  function YesNoData() {
    _classCallCheck(this, YesNoData);

    return _possibleConstructorReturn(this, _getPrototypeOf(YesNoData).apply(this, arguments));
  }

  _createClass(YesNoData, [{
    key: "setGradeType",
    value: function setGradeType(grade) {
      if (this.resultGradeFlip) {
        // Nand the result as a 'true' value grade is not always positive
        grade = !(this.resultGradeFlip && grade);
      } // If 'grade' is true, that's good


      this.gradeType = grade ? GradeTypeConstants.GOOD : GradeTypeConstants.BAD;
    }
  }, {
    key: "setDisplayValue",
    value: function setDisplayValue() {
      var yesText = I18n.text('results.data.yep');
      var noText = I18n.text('results.data.nah');
      this.displayValue = this.gradeType === GradeTypeConstants.BAD && this.resultGradeFlip ? yesText : noText;
      this.displayRecommendationValue = this.resultGradeFlip ? noText : yesText;
    }
  }]);

  return YesNoData;
}(ComponentData);

export default YesNoData;